module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 1.c18cc9a7.png";